
export const ROUTER_PATHS = {
  // BASE field is the prefix for modules w/ child routing
  // For modules w/ base routing that need to access parent's query param (clientId),
  // use activatedRoute.parent

  AUTH: {
    BASE: 'auth',
    LOGIN: 'login',
    FORGOT_PASSWORD: 'forgot-password',
    RESET_PASSWORD: 'reset-password',
    SET_PASSWORD: 'set-password',
  },

  CLIENT: {
    BASE: '',
    LIST: 'clients',
    DETAILS: ':clientId',
    CUSTOMERS: ':clientId/customers',
    USERS: ':clientId/users',
    REPORTS: ':clientId/reports',
    CUSTOMER_REPORT: ':clientId/reports/customer-report',
    INVOICE_REPORT: ':clientId/reports/invoice-report',
    INVOICE_REPORT_DETAIL: ':customerId/invoice/:invoiceId',
    USER_REPORT: ':clientId/reports/user-report',
    ORDER_REPORT: ':clientId/reports/order-report',
  },

  CUSTOMER: {
    BASE: ':clientId/customers',
    ADD_CUSTOMER: 'new',
    PROSPECTS: 'prospects',
    ADD_PROSPECT: 'prospects/new',
    PROSPECT_DETAILS: 'prospects/:leadId',
    DETAILS: ':customerId',
    OVERVIEW: 'overview',
    PRICING: 'pricing',
    TAXES: 'taxes',
    ACCOUNT: 'account',
    LOCATIONS: 'locations',
    ORDERS: 'orders',
    USERS: 'users',
    ADD_CUSTOMER_USER: ':customerId/add-user',
    CUSTOMER_USER_DETAILS: ':customerId/users/:userId',
    EDIT_CUSTOMER_USER: ':customerId/users/:userId/edit',
    NOTES: 'notes',
    INVOICES_AND_PAYMENTS: 'financials',
    ORDER_NOTES: ':customerId/orders/:orderId/notes',
    SERVICE_NOTES: ':customerId/service/:serviceId/notes',
    INVOICE_DETAILS: ':customerId/invoice/:invoiceId',
    STATEMENT_DETAILS: ':customerId/batch/:batchId/statement/:statementId',
    SERVICE_REQUEST_DETAILS: ':customerId/service/:serviceId',
    BUDGET_PLAN: ':customerId/budget-plan',
    ASSOCIATED_ACCOUNTS: 'associated-accounts',
    INTERNAL_MESSAGING: 'internal-messaging',
    SYSTEM_LOGS: 'system-logs',
    SUBSCRIPTIONS: 'subscriptions',
    SUBSCRIPTIONS_INVOICE: 'invoice',
    SUBSCRIPTIONS_ASSET_RENTAL: 'asset-rental',
    SUBSCRIPTIONS_STATEMENT: 'statement',
    SUBSCRIPTIONS_INSPECTION: 'inspection',
  },

  CUSTOMER_LOCATION: {
    BASE: ':customerId/locations/:locationId',
    TANKS: 'tanks',
    PRODUCTS: 'products',
    ADD_TANKS: ':customerId/locations/:locationId/tanks/add',
    ORDERS: 'orders',
    PRICING: 'pricing',
    DETAILS: 'details',
    PROPANE_DELIVERY: 'propane-delivery',
    SERVICE_TICKETS: 'service-tickets',
    AUTO_ORDERS: 'auto-orders',
    NOTES: 'notes',
    EQUIPMENT: 'equipment',
    TAX: 'tax',
    MISCELLANEOUS_CHARGES: 'miscellaneous-charges',
    DETAILS_INSPECTION_HISTORY: 'details-inspection-history',
    INSPECTIONS: 'inspections',
    INSPECTION_DETAILS: 'inspections/:inspectionId',
    INSPECTION_CREATE: 'inspections/create',
    EQUIPMENT_ASSET_INSPECTION_DETAILS: 'equipment/inspections/:inspectionId',
    EQUIPMENT_ASSET_INSPECTION_CREATE: 'equipment/inspections/create',
    INSPECTION_HISTORY: ':customerId/locations/:locationId/equipment/:equipmentId/inspection-history',
    SERVICE_NOTES: ':customerId/locations/:locationId/service/:serviceId/notes',
    ASSETS_DETAILS: ':customerId/locations/:locationId/assets/:assetId',
  },

  CUE_SYSTEM_SETUP: {
    EMPLOYEES_BASE: ':clientId/cue-system-setup',
    USERS: 'users',
    ROLES: 'roles',
    CUSTOMER_ROLES: 'customer',
    BASE: ':clientId/users',
    ADD_USER: 'users/new',
    DETAILS: 'users/:userId',
    EDIT: 'users/:userId/edit',
    ADD_USER_CUSTOMER: 'users/:userId/add-customer',
    CREATE_ROLE: 'roles/new',
    ROLE_DETAILS: 'roles/employee/:roleId',
    EDIT_ROLE: 'roles/employee/:roleId/edit',
    CUSTOMER_ROLE_DETAILS: 'roles/customer/:roleId',
    EDIT_CUSTOMER_ROLE: 'roles/customer/:roleId/edit',
    CUSTOMER_TYPE: 'customer-type',
    CUSTOMER_TYPE_DETAILS: 'customer-type/:customerTypeId',
    CUSTOMER_TYPE_CUSTOMER_DETAILS: 'customer-type/:customerTypeId/customer/:customerId',
    GROUPS: 'groups',
    GROUP_DETAILS: 'groups/:groupId',
    GROUP_CUSTOMER_DETAILS: 'groups/:groupId/customer/:customerId',
    GROUP_PRODUCT_DETAILS: 'groups/:groupId/product/:productId',
    ACCOUNTING_PERIOD: 'accounting-period',
    BACKDATING_CONTROL: 'backdating-control',
    FINANCE_CONFIG: 'finance-config',
    FINANCE_CONFIG_ACCOUNTING_PERIOD: 'finance-config/accounting-period',
    FINANCE_CONFIG_BACKDATING_WINDOWS: 'finance-config/backdating-windows',
    INTEGRATION_ADMIN: 'integration-admin',
    DELIVERY_ZONE: 'delivery-zone',
    DELIVERY_ZONE_DETAILS: 'delivery-zone/:deliveryZoneId',
    DELIVERY_PROTOCOL: 'delivery-protocol',
    DELIVERY_PROTOCOL_DETAILS: 'delivery-protocol/:deliveryProtocolId',
    REGION: 'region',
    REGION_DETAILS: 'region/:regionId',
    STATEMENT_TYPES: 'statement-types',
    STATEMENT_TYPE_DETAILS: 'statement-types/:statementTypeId',
    STATEMENT_ANOMALY_SETTINGS: 'statement-anomaly-settings',
    SCHEDULED_JOBS: 'scheduled-jobs',
    SCHEDULED_JOB_DETAILS: 'scheduled-jobs/:scheduledJobsId',
    BINS: 'bins',
    DELIVERY_GROUP: 'delivery-group',
    DELIVERY_GROUP_DETAILS : 'delivery-group/:deliveryGroupId',
    PAYMENT_CONFIGURATION: 'payment-configuration',
    PRICE_CODES: 'price-codes',
    PRICE_CODE_DETAILS: 'price-codes/:priceCodeId',
    ADJUSTMENTS: 'adjustments',
    ADJUSTMENT_CODE_DETAILS: 'adjustments/:adjustmentCodeId',
    INTERNAL_MESSAGING: 'internal-messaging',
    INTERNAL_MESSAGING_MEMO_TYPE: 'internal-messaging/memo-type',
    INTERNAL_MESSAGING_MEMO_CODE: 'internal-messaging/memo-code',
    INTERNAL_MESSAGING_MEMO_ROUTING_CONFIGURATION: 'internal-messaging/routing-configuration',
    NOTE_TYPE_CONFIGURATION: 'note-type',
  
    LOSS_CODES: 'loss-codes',
    NPS_SETTINGS: 'nps-settings',
    TAX_MANAGEMENT: 'tax-management',
    PRODUCT_CATEGORIES: 'product-categories',
    PRODUCT_CATEGORY_DETAILS: 'product-categories/:categoryId',
    BRANDS: 'brands',
    BRAND_DETAILS: 'brands/:brandId',
    SUPPLIERS: 'suppliers',
    SUPPLIER_DETAILS: 'suppliers/:supplierId',
    MISCELLANEOUS_CHARGES: 'miscellaneous-charges',
    MISCELLANEOUS_CHARGES_CREATE: 'miscellaneous-charges/create',
    MISCELLANEOUS_CHARGE_DETAILS: 'miscellaneous-charges/:chargeId',
    INSPECTIONS: 'inspections',
    INSPECTION_TYPE_DETAILS: 'inspections/:inspectionTypeId',
    CREDIT_RULES: 'credit-rules',
    ASSET_RENTAL_CONFIG: 'asset-rental-config',
    ASSET_RENTAL_CONFIG_ASSET_TYPES: 'asset-rental-config',
    ASSET_RENTAL_CONFIG_RENTAL_CONFIGURATION: 'asset-rental-config/rental-configuration',
    ASSET_TYPE_DETAILS: 'asset-rental-config/:assetTypeId',
    BUDGET_PAYMENT_CONFIG: 'budget-payment-config',
    SERVICE_CONFIG: 'service-config',
    SERVICE_TYPE_CREATE: 'service-config/service-types/new',
    SERVICE_TYPE_DETAILS: 'service-config/service-types/:serviceTypeId',
    TECHNICIAN_SKILL_CREATE: 'service-config/technician-skills/new',
    TECHNICIAN_SKILL_DETAILS: 'service-config/technician-skills/:competencyId',
    SERVICE_FORM_DETAILS: 'service-config/service-forms/:formId',
  },

  PRODUCT_MANAGEMENT: {
    BASE: ':clientId/product-management',
    PRODUCTS: 'products',
    REGIONS: 'regions',
    CATEGORIES: 'categories',
    ATTRIBUTES: 'attributes',
    PRODUCT_DETAIL: 'products/:productId',
    PRODUCT_EDIT: 'products/:productId/edit',
    PRODUCT_ADD: 'products/add',
    PRICING: 'pricing',
    TAXES: 'taxes',
  },

  LEAD: {
    BASE: ':clientId/leads',
    LIST: 'all-leads',
    DETAILS: ':leadId',
    ADD_LEAD: 'new',
  },

  DEV_DASHBOARD: {
    BASE: ':clientId/dev-dashboard',
    EDI_LOGS: 'edilogs',
    CUSTOMER_ADDRESSES: 'customer-addresses',
    INVOICES: 'invoices',
    INVOICE_DETAIL: 'invoices/:invoiceId/:customerId'
  },

  PAGE_NOT_FOUND: '404',
  INVALID_INVITE: 'invalid-invite',

  DEEPLINK: {
    BASE: 'link/:type',
  },

  ORDER_MANAGEMENT: {
    BASE: ':clientId/order-management/orders',
    ALL: 'all',
    NEW: 'new',
    DELIVERY: 'delivery',
    DELIVERED: 'delivered',
    CREDIT_HOLD: 'credit-hold',
    REVIEWED: 'reviewed',
    UNSCHEDULED: 'unscheduled',
    NO_FILL: 'no-fill',
    COMPLETED: 'completed',
    CANCELED: 'canceled',
    INVOICES: 'invoices',
    INVOICE_DETAIL: 'invoices/:invoiceId/:customerId',
    PROCESSED: 'processed',
    LABELS_CREATED: 'labels-created',
    SHIP_ORDERS: 'ship-orders',
    STAGING_ORDERS: 'staging',
    CANCELLED_ORDERS: 'cancelled',
    ORDER_DETAILS: 'orders/:orderId',
    PROCESSED_ORDER_DETAILS: 'processed/:orderId',
    NOTES: ':orderId/notes'
  },

  MANUFACTURING: {
    BASE: ':clientId/manufacturing',
    PRODUCTION_PLANNING: 'production-forecast',
    PRODUCTION_HISTORY: 'production-history',
    PRODUCTION_SCHEDULE: 'production-schedule',
    PLAN_PRODUCTION: 'production-schedule/plan-production/:productId',
    PLAN_PRODUCTION_OPEN_LOTS: 'production-schedule/plan-production',
    CREATE_LOTS: 'production-schedule/plan-production/:productId/create-lot',
    LOT_DETAILS: ':lotId',
    EDIT_LOT_DETAILS: ':lotId/edit',
    LOG_PRODUCTION: ':lotId/log-production',
    LOG_PRODUCTION_SCHEDULE: ':lotId/log-production/:scheduleId',
    OPEN_LOTS: 'open-lots',
  },

  INVENTORY_MANAGEMENT: {
    BASE: ':clientId/inventory-management',
    MANAGE_INVENTORY: 'manage',
    MANAGE_INVENTORY_BY_PRODUCT_ID: 'product',
    MANAGE_INVENTORY_BY_LOT_NUM: 'lot',
    FINISHED_GOODS: 'finished-goods',
    RAW_MATERIALS: 'raw-materials',
    RESTRICTED_STOCK: 'restricted-stock',
    SEMI_FINISHED_GOODS: 'semi-finished-goods',
    RESTRICTED_STOCK_DETAILS: 'restricted-stock/:inventoryId',
    RAW_MATERIALS_INVENTORY: 'raw-materials/:materialId',
    INVENTORY_DETAILS: 'inventory/:productId',
    INVENTORY_LOT_DETAILS: 'inventory/:productId/:inventoryId',
    FINISHED_GOODS_DETAILS: 'manufacturing/:manufacturingId',
    SEMI_FINISHED_GOODS_INVENTORY: 'semi-finished-goods/:materialId',
    RECEIVING: 'receiving',
    STOCK_INVENTORY: 'material-inventory',
    RECEIVE_MATERIAL_DETAILS: 'receiving/material-inventory/:materialId',
    ADD_TO_INVENTORY: 'receiving/add-to-inventory/:materialId',
    RECEIVE_MATERIAL_STOCK: 'receiving/material-inventory/receive-stock/:materialId',
    RAW_MATERIALS_DETAILS: 'raw-materials/:materialId/:inventoryId',
    SEMI_FINISHED_GOODS_DETAILS: 'semi-finished-goods/:materialId/:inventoryId',
    WAREHOUSES: 'warehouses',
    WAREHOUSE_LOCATIONS: 'warehouses/:warehouseId',
    BATCH_SHIPPING: 'shipping',
    PICK_TICKETS: 'pick-tickets',
    PICK_TICKET_DETAILS: 'pick-tickets/:ticketId',
    OPERATOR: 'operator',

    STORAGE: 'storage',
    INVENTORY_MOVEMENTS: 'inventory-movements',
    MOVEMENT_UPLOAD_DETAILS: 'inventory-movements/upload-details/:uploadId',
    STORAGE_DETAILS: 'storage/:inventoryId',
    RENTAL_TANK_DETAILS: 'rental-tank/:inventoryId',
    APPLIANCE_DETAILS: 'appliance/:inventoryId',
    RENTAL_TANKS: 'rental-tanks',
    APPLIANCES: 'appliances'
  },

  MATERIALS: {
    BASE: ':clientId/materials',
    MATERIAL_ADD: 'raw-materials/add',
    SEMI_FINISHED_GOOD_ADD: 'semi-finished-good/add',
    SEMI_FINISHED_GOOD_ADD_INFO: 'semi-finished-good/add/info',
    RAW_MATERIAL_ADD_INFO: 'raw-materials/add/info',
    ATTRIBUTES: 'attributes',
    OTHERS: 'semi-finished-goods',
    MATERIAL_DETAILS_BASE: ':materialId',
    DEACTIVATED_MATERIALS: 'deactivated',
    RAW_MATERIALS_PAGE: 'raw-materials',
    MATERIAL_DETAILS_EDIT: ':materialId/edit'
  },

  VENDORS: {
    BASE: ':clientId/vendors',
    VENDOR_ADD: 'add',
    VENDOR_DETAILS: ':vendorId',
    VENDDOR_MATERIAL_DETAILS: ':vendorId/vendor-material'
  },

  SITE_MANAGEMENT: {
    BASE: ':clientId/site-management',
    SITE_ADD: 'add',
    SITE_DETAILS: ':customerId/:siteId',
    EDIT: ':customerId/:siteId/edit'
  },

  PROFILE: {
    BASE: ':clientId/profile/:userId'
  },

  SHIPPING: {
    BASE: ':clientId/shipping'
  },

  WORKBENCH: {
    BASE: ':clientId/workbench',
    POSTINGS: 'postings',
    PAYMENT_UPLOADS: 'payment-uploads',
    AR_BALANCE_AGING: 'ar-balance-aging',
    ADJUSTMENTS: 'adjustments',
    CREDIT_REBILL: 'credit-rebill',
    FINANCE_CHARGES: 'finance-charges',
    UPLOAD_DETAILS: 'upload-details/:uploadId',
  },

  GAS_PRICING: {
    BASE: ':clientId/gas-pricing',
    REGION_OVERVIEW: 'region-overview',
    BRANCH_PRICING: 'branch-pricing',
    PRICING_STRUCTURES: 'pricing-structures',
    PRODUCT_PRICING: 'product-pricing',
    UPLOAD_HISTORY: 'upload-history',
    PRICING_GROUPS: 'pricing-groups',
    PRICING_GROUPS_DETAILS: 'pricing-groups/:pricingGroupId',
    CUSTOMER_PRICING: 'customer-pricing',
    FIXED_PRICE_GROUP_CONTRACTS: 'fixed-price-group-contracts',
    FIXED_PRICE_GROUP_CONTRACT_DETAILS: 'fixed-price-group-contracts/:contractId',
    CUSTOMER_PRICING_DETAILS: 'customer-pricing/:customerId',
    PROMOTIONS: 'promotions',
  },

  SERVICE_MANAGEMENT: {
    BASE: ':clientId/service-request',
    CREATE: 'create',
    NOTES: ':serviceId/notes',
    DETAILS: ':serviceId',
    FORM: ':serviceId/:placementId',
    TECHNICIAN_DETAILS: 'technicians/:technicianId',
  },

  DELIVERY_MANAGEMENT: {
    BASE: ':clientId/delivery-management',
    NOTES: ':deliveryId/notes'
  },

  DELIVERY_PLANNING_MANAGEMENT: {
    BASE: ':clientId/delivery-planning-management',
    DELIVERY_QUEUE: 'delivery-queue/:regionId'
  },

  PROMOTIONS: {
    BASE: ':clientId/promotions',
    LIST: '',
    CREATE: 'create',
    EDIT: ':promotionId/edit',
    DETAIL: ':promotionId',
    PRIORITY: 'priority',
  },

  STATEMENTS: {
    BASE: ':clientId/statements',
    STATEMENT_BATCHES: 'statement-batches',
    ALL_STATEMENTS: 'all-statements',
    STATEMENT_AUTOMATION: 'statement-automation',
    CREATE_STATEMENT_BATCH: 'statement-batches/create',
    CREATE_STATEMENT_AUTOMATION: 'statement-automation/create',
    BATCH_DETAILS: 'statement-batches/:batchId',
    STATEMENT_AUTOMATION_DETAILS: 'statement-automation/:automationId',
    BATCH_STATEMENT_DETAILS: 'statement-batches/:batchId/:customerId/:statementId'
  },

  ADJUSTMENTS: {
    BASE: ':clientId/adjustment',
    ADJUSTMENTS: 'adjustments',
    ADJUSTMENT_UPLOADS: ':adjustment-upload',
    UPLOAD_DETAILS: 'upload-details/:uploadId'
  },

  BUDGET_ACCOUNTS_MANAGEMENT: {
    BASE: ':clientId/budget-accounts-management',
    ACCOUNTS_REVIEW: 'accounts-review',
    END_OF_SEASON: 'end-of-season',
    PLAN_RENEWAL: 'plan-renewal',
    UPDATE_HISTORY: 'update-history',
  },

  ASSET_MANAGEMENT: {
    BASE: ':clientId/asset-management',
    ASSETS: 'assets',
    ASSETS_ADD: 'assets/add',
    ASSET_INSPECTIONS: 'asset-inspections',
    MODULE_INSPECTIONS_CREATE: 'inspections/create',
    ASSET_DETAILS: 'assets/:assetId',
    ASSET_REGISTRY: 'asset-registry',
    INSPECTIONS: 'inspections',
    INSPECTIONS_CREATE: 'inspections/create',
    INSPECTION_DETAILS: 'inspections/:inspectionId',
    MOVEMENT: 'movement',
    RENTALS: 'rentals',
    CREATE_RENTAL_BILLING_BATCH: 'rentals/create-batch',
    RENTAL_BILLING_BATCH_DETAILS: 'rentals/batches/:batchId',
    CREATE_RENTAL_BILLING_AUTOMATION: 'rentals/automation/create',
    RENTAL_BILLING_AUTOMATION_DETAILS: 'rentals/automation/:automationId',
    UPLOAD_HISTORY: 'upload-history',
    NOTES: 'notes',
    ATTACHMENTS: 'attachments',
    BILLING: 'billing',
  },

  INSPECTION_MANAGEMENT: {
    BASE: ':clientId/inspection-management',
    INSPECTION_CREATE: 'create',
    INSPECTION_DETAILS: ':inspectionId'
  },
}
